import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { OrganisationInteractionService } from '../../../services';
import { IOrganisationInteraction } from '../../../interfaces/interactions/organisation-interaction';

@Component({
  selector: 'interactions-list',
  styleUrls: ['./interactions-list.component.scss'],
  templateUrl: './interactions-list.component.html',
})
export class InteractionsListComponent implements OnInit {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private interactionService: OrganisationInteractionService,
  ) {}

  selectedOrganisationId?: number;
  interactions: IOrganisationInteraction[] = [];
  selectedInteraction: any;

  ngOnInit() {}

  loadInteractions() {
    if (!this.selectedOrganisationId) {
      return;
    }

    this.interactionService.getInteractions(this.selectedOrganisationId).then((result) => {
      this.interactions = result;
    });
  }

  onOrganisationSelected(orgId: number) {
    this.selectedOrganisationId = orgId;
    this.loadInteractions();
  }
}
